// Specialty field (Primary Unit/Specialty)
export enum NursingSpecializations {
  'Emergency Department (ED)' = 'ED',
  'Intensive Care Unit (ICU)' = 'ICU',
  'Step-Down / Progressive Care (PCU)' = 'PCU',
  Telemetry = 'Telemetry',
  'Medical-Surgical (Med-Surg)' = 'Med-Surg',
  'Operating Room (OR)' = 'OR',
  'Post-Anesthesia Care Unit (PACU)' = 'PACU',
  'Labor & Delivery (L&D)' = 'L&D',
  'Postpartum / Mother-Baby' = 'Mother-Baby',
  'Neonatal ICU (NICU)' = 'NICU',
  'Pediatric ICU (PICU)' = 'PICU',
  'Pediatrics (Med-Surg/Onc)' = 'Pediatrics',
  Oncology = 'Oncology',
  'Behavioral Health / Psychiatry' = 'Psychiatry',
  'Inpatient Rehabilitation' = 'Rehab',
  Dialysis = 'Dialysis',
  'Observation Unit' = 'Observation',
  'Float Pool' = 'Float Pool',
}
